import { ETLCourse } from './types';

export const AWS_GLUE_COURSE: ETLCourse = {
  id: 'aws-glue-dataflow',
  title: 'AWS Glue & Google Dataflow Mastery',
  description: 'Master cloud-native ETL with AWS Glue and Google Cloud Dataflow. Build serverless data pipelines that scale automatically.',
  level: 'intermediate',
  totalDuration: '14-18 hours',
  image: '/api/placeholder/400/250',
  toolFocus: 'Cloud ETL',
  marketDemand: 'high',
  salaryRange: '$100,000 - $170,000',
  prerequisites: [
    'Python programming proficiency',
    'SQL and data modeling knowledge',
    'Basic cloud computing concepts',
    'Understanding of ETL principles'
  ],
  learningOutcomes: [
    'Design and deploy AWS Glue ETL jobs',
    'Build streaming pipelines with Google Dataflow',
    'Implement serverless data processing workflows',
    'Master cloud data catalog and schema management',
    'Optimize costs and performance in cloud ETL',
    'Integrate with cloud data warehouses and lakes'
  ],
  modules: [
    {
      id: 'aws-glue-1',
      title: 'AWS Glue Fundamentals and Data Catalog',
      description: 'Master AWS Glue architecture, data catalog, and crawler setup',
      duration: '6 hours',
      difficulty: 'beginner',
      order: 1,
      objectives: [
        'Understand AWS Glue architecture and components',
        'Set up AWS Glue Data Catalog',
        'Configure crawlers for automatic schema discovery',
        'Create and manage databases and tables'
      ],
      content: 'AWS Glue is a fully managed ETL service that makes it easy to prepare and load data for analytics. This module covers the fundamentals of AWS Glue architecture, data catalog setup, and crawler configuration for automated metadata management.'
    },
    {
      id: 'aws-glue-2', 
      title: 'AWS Glue ETL Jobs and PySpark Development',
      description: 'Build sophisticated ETL jobs using PySpark and Glue Studio',
      duration: '4 hours',
      difficulty: 'intermediate',
      order: 2,
      objectives: [
        'Develop PySpark ETL jobs in AWS Glue',
        'Implement advanced data transformations',
        'Master Glue Studio visual interface',
        'Build data quality and validation frameworks'
      ],
      content: 'Learn to build sophisticated ETL jobs using PySpark in AWS Glue. This module covers advanced transformations, Glue Studio visual development, and implementing comprehensive data quality frameworks.'
    },
    {
      id: 'aws-glue-3',
      title: 'Google Cloud Dataflow and Advanced Streaming',
      description: 'Master Google Cloud Dataflow with Apache Beam for streaming pipelines',
      duration: '4 hours',
      difficulty: 'advanced',
      order: 3,
      objectives: [
        'Build Apache Beam pipelines for Google Dataflow',
        'Implement streaming data processing',
        'Master real-time analytics and windowing',
        'Integrate with Google Cloud services'
      ],
      content: 'Master Google Cloud Dataflow with Apache Beam to build real-time streaming data pipelines. Learn advanced streaming concepts, windowing, and integration with Google Cloud services.'
    }
  ]
};

export const MODERN_ELT_COURSE: ETLCourse = {
  id: 'modern-elt-tools',
  title: 'Modern ELT Tools: Fivetran, Airbyte & CDC',
  description: 'Master modern ELT platforms and Change Data Capture. Build automated data pipelines with Fivetran, Airbyte, and real-time CDC solutions.',
  level: 'intermediate',
  totalDuration: '12-16 hours',
  image: '/api/placeholder/400/250',
  toolFocus: 'Modern ELT',
  marketDemand: 'high',
  salaryRange: '$95,000 - $165,000',
  prerequisites: [
    'SQL and database fundamentals',
    'Understanding of ETL/ELT concepts',
    'Basic cloud platform knowledge',
    'API integration experience'
  ],
  learningOutcomes: [
    'Configure and manage Fivetran connectors',
    'Deploy and scale Airbyte pipelines',
    'Implement Change Data Capture solutions',
    'Build real-time data streaming architectures',
    'Monitor and optimize ELT performance',
    'Design fault-tolerant data integration systems'
  ],
  modules: [
    {
      id: 'modern-elt-1',
      title: 'Fivetran Mastery and Connector Management',
      description: 'Master Fivetran for automated data integration and enterprise deployment',
      duration: '4 hours',
      difficulty: 'beginner',
      order: 1,
      objectives: [
        'Set up and configure Fivetran connectors',
        'Implement automated schema management',
        'Master data transformation and modeling',
        'Deploy enterprise Fivetran solutions'
      ],
      content: 'Learn to master Fivetran for automated data integration. This module covers connector configuration, schema management, transformations, and enterprise deployment patterns.'
    },
    {
      id: 'modern-elt-2',
      title: 'Airbyte and Open-Source ELT Solutions',
      description: 'Deploy and manage Airbyte for scalable data integration',
      duration: '4 hours',
      difficulty: 'intermediate',
      order: 2,
      objectives: [
        'Deploy Airbyte in production environments',
        'Configure and manage Airbyte connectors',
        'Develop custom connectors using CDK',
        'Implement monitoring and scaling strategies'
      ],
      content: 'Master Airbyte deployment and management for scalable data integration. Learn to configure connectors, develop custom solutions, and implement production monitoring.'
    },
    {
      id: 'modern-elt-3',
      title: 'Change Data Capture (CDC) and Real-time Streaming',
      description: 'Master Change Data Capture and build real-time streaming architectures',
      duration: '4 hours',
      difficulty: 'advanced',
      order: 3,
      objectives: [
        'Implement various CDC patterns and technologies',
        'Build real-time streaming data architectures',
        'Master Kafka-based event-driven pipelines',
        'Design fault-tolerant streaming systems'
      ],
      content: 'Master Change Data Capture techniques and real-time streaming architectures. Learn to implement CDC patterns, build Kafka-based pipelines, and design fault-tolerant systems.'
    }
  ]
};